export default __webpack_public_path__ + "media/images/phone-a82ce1988c775f04ddce4dedddb137e5.svg";